/* =====================================================================
   El botón «atrás» del navegador lleva al inicio de TEGO · 19 sep 2026
   =====================================================================
   Medido: quien llegaba directo a `/app/?ir=login` (o a cualquier
   pantalla de la aplicación) y pulsaba «atrás» salía del sitio, porque la
   aplicación es una sola página y no deja entradas en el historial.

   Lo que hace esto, una sola vez por carga:
     1. Convierte la entrada actual del historial en la portada (`/`).
     2. Añade encima la entrada de la aplicación, con la URL tal cual.
   Así «atrás» cae en la portada —una navegación completa a `/`, que es
   la página pública de TEGO— y «adelante» vuelve a la aplicación.

   Sin bucles: la portada es una página distinta (no esta), así que su
   «atrás» sigue al historial anterior del navegador, y aquí no se vuelve
   a empujar nada si la entrada ya es nuestra (`state.tego`).

   DESDE EL 3 DE OCTUBRE DE 2026 ESTO ES UNA FACHADA · TC-DR-AT.
   Lo de arriba cuenta cómo era: una sola entrada para toda la sesión, y
   por eso «atrás» desde Entrada o desde Punto de venta caía en la
   portada. Ahora el historial tiene UNA sola puerta, `ui/navegacion.js`,
   y este archivo solo le delega: siembra el centinela y la entrada de la
   aplicación con la dirección intacta. Sin sesión, atrás sigue saliendo
   a la portada; con sesión, la raíz avisa antes de salir y cada pantalla
   vuelve a la anterior. Se conserva el archivo, sus nombres exportados y
   la línea de `App.jsx` que lo llama.
   ===================================================================== */
import { crearNavegacion, entornoDe, navegacion } from '../ui/navegacion';

// Los valores del truco anterior. El módulo de navegación reconoce
// `inicio` en una pestaña abierta desde antes del despliegue.
export const ESTADO_APP = 'app';
export const ESTADO_INICIO = 'inicio';

export function destinoDeRetorno(location = window.location) {
  // En producción la portada vive en `/` del mismo origen (nginx sirve
  // inicio.html); da igual si se entró por nombre o por IP.
  return `${location.protocol}//${location.host}/`;
}

/** Siembra el historial una vez por carga. Devuelve true si sembró. */
export function asegurarRetorno(win = window) {
  const h = win.history;
  if (!h || typeof h.pushState !== 'function') return false;
  // La ventana de verdad usa la instancia única; otra ventana (las
  // pruebas pasan un doble) recibe la suya.
  const nav = win === window ? navegacion : crearNavegacion(entornoDe(win));
  return nav.iniciar({ centinela: true });
}
